import { useEffect } from "react";

export const CheckoutCancelledPage = () => {
  useEffect(() => {
    // If this window was opened by window.open(), notify the opener and close
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        {
          type: "STRIPE_CHECKOUT_CANCELLED",
        },
        window.location.origin
      );
      window.close();
      return;
    }

    // Fallback if not opened as popup - redirect to home
    window.location.href = "/";
  }, []);

  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="space-y-4 text-center">
        <h1 className="text-2xl font-bold text-orange-600">Paiement annulé</h1>
        <p className="text-muted-foreground">
          Cette fenêtre va se fermer automatiquement...
        </p>
      </div>
    </div>
  );
};
